import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getAllRolesReport = async (): Promise<any> => {
  let url = `/admin/report-roles`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response;
};

export const addNewMappingReport = async (formData:any): Promise<any> => {
  let url = `/admin/report-roles`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const getMasterTableSync = async (): Promise<any> => {
    let url = `/admin/master-data-sync/options`;
    const response = await axios.get<any>(url, {
      headers: getHeader(),
    });
    return response.data;
  };

  export const getStatusMaster = async (batch_job_id:any): Promise<any> => {
 
    let url = `/admin/master-data-sync/${batch_job_id}/status`;
    const response = await axios.get<any>(url, {
      headers: getHeader(),
    });
    return response.data;
  };


export const addMasterTableSync = async (formData: FormData): Promise<any> => {
    let url = `admin/trigger-master-data-sync`;
    const response = await axios.post<any>(url, formData, {
      headers: getHeader(),
    });
    return response.data;
  };

    
export const addRoadnet = async (formData: FormData): Promise<any> => {
  let url = `admin/roadnet-sync`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};


